var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5385 7.14363H18.1923V5.79748C18.1923 4.16378 16.8645 2.83594 15.2308 2.83594H4.46154C2.82785 2.83594 1.5 4.16378 1.5 5.79748V15.5759C1.5 16.0692 1.76923 16.5226 2.20215 16.7584C2.40462 16.8682 2.62538 16.9221 2.84615 16.9221C3.10138 16.9221 3.35662 16.8499 3.57954 16.7046L5.53523 15.437C5.62031 15.3821 5.714 15.3455 5.80769 15.311V16.5667C5.80769 18.2004 7.13554 19.5282 8.76923 19.5282H17.096C17.7734 19.5282 18.4314 19.7232 19.0011 20.0904L20.4205 21.0112C20.6434 21.1566 20.8975 21.2287 21.1538 21.2287C21.3746 21.2287 21.5954 21.1738 21.7978 21.065C22.2308 20.8292 22.5 20.3758 22.5 19.8826V10.1041C22.5 8.4704 21.1722 7.14363 19.5385 7.14363ZM4.65538 14.0822L3.11538 15.0806V5.79748C3.11538 5.05548 3.71954 4.45132 4.46154 4.45132H15.2308C15.9728 4.45132 16.5769 5.05548 16.5769 5.79748V12.259C16.5769 13.001 15.9728 13.6052 15.2308 13.6052H6.26646C5.69246 13.6052 5.13462 13.7699 4.65538 14.0822ZM20.8846 19.3872L19.8788 18.7356C19.0485 18.1982 18.0857 17.9129 17.096 17.9129H8.76923C8.02723 17.9129 7.42308 17.3087 7.42308 16.5667V15.2206H15.2308C16.8645 15.2206 18.1923 13.8927 18.1923 12.259V8.75901H19.5385C20.2805 8.75901 20.8846 9.36317 20.8846 10.1052V19.3872Z",
    fill: "#F8FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat);
export default __webpack_public_path__ + "static/media/live-chat.ee2ebfd96430bbd1dab42d7875e8db73.svg";
export { ForwardRef as ReactComponent };